var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("default",[_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-account")])],1)],{"on":on,"attrs":attrs})]}}],null,true)},[_c('v-list',[_c('v-list-item',{attrs:{"to":"#"}},[_c('v-list-item-title',{on:{"click":_vm.Logout}},[_vm._v("Odhlásiť")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }